<div class="center-msg center-msg-v2">
  <div class="item success">
    <div class="img">
      <img src="assets/image/medalha_3k.png" alt="" />
    </div>
    <div class="text">
      <div class="t-5">
        Parabéns! <br />
        Seu cadastro está aguardando aprovação para <strong>USD 3.000,00</strong> ao ano de
        limite operacional. <br />
        Deseja continuar e <strong>alcançar um limite maior?</strong>
      </div>
    </div>
    <div class="link link-v2">
      <div class="row d-flex justify-content-center">
        <div class="col-md-5">
          <div class="form-group">
            <button (click)="goHome()" type="button" class="btn-xp-m2 btn-blue-30-b btn-block w-100">
              Não
            </button>
          </div>
        </div>
        <div class="col-md-5">
          <div class="form-group">
            <button (click)="goNext()" type="button" [disabled]="loading" class="btn-xp-m2 btn-blue-30 btn-block">
              Sim
              <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
